import state from './moduleCashBookTemporaryState.js'
import mutations from './moduleCashBookTemporaryMutations.js'
import actions from './moduleCashBookTemporaryActions.js'
import getters from './moduleCashBookTemporaryGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

